import React from 'react';
import { Link } from 'react-router-dom';
import { Icons } from '@/src/modules/components/Icons';
import { BrandLogo } from '@/src/modules/components/BrandLogo';
import { useAuthStore } from '@/src/modules/auth/useAuthStore';
import { trackEvent } from '@/src/infrastructure/lib/analytics';
import { cn } from '@/src/infrastructure/lib/utils';

interface CartCheckoutHeaderProps {
  maxWidth?: string;
}

export function CartCheckoutHeader({ maxWidth = 'max-w-5xl' }: CartCheckoutHeaderProps) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated());
  const homeHref = isAuthenticated ? '/dashboard' : '/';
  const homeLabel = isAuthenticated ? 'Dashboard' : 'Home';

  const handleNavClick = () => {
    trackEvent(
      'PUBLIC_CLICK',
      'navigation',
      isAuthenticated ? 'cart_checkout_to_dashboard' : 'cart_checkout_to_home',
      undefined,
      { element_id: 'cart_checkout_home_nav' }
    );
  };

  return (
    <header className="sticky top-0 z-30 border-b border-outline-variant/30 bg-surface/80 backdrop-blur-md">
      <div className={cn('mx-auto flex items-center justify-between px-5 py-4 sm:px-8', maxWidth)}>
        <Link
          to={homeHref}
          onClick={handleNavClick}
          data-track="cart-checkout-home-link"
          className="flex items-center gap-2 rounded-xl p-2 text-on-surface-variant transition-colors hover:bg-surface-low hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
          aria-label="Home"
          title={isAuthenticated ? 'Go to Dashboard' : 'Go to Home'}
        >
          <Icons.Home size={20} />
          <span className="text-sm font-semibold">
            {homeLabel}
          </span>
        </Link>

        <div className="flex items-center">
          <BrandLogo variant="full" size="md" href={homeHref} />
        </div>
      </div>
    </header>
  );
}
